import {
    UPDATE_CALL_STATUS_START,
    UPDATE_CALL_STATUS_SUCCESS,
    UPDATE_CALL_STATUS_FAILURE,
    MARK_CALL_RECEIVED_START,
    MARK_CALL_RECEIVED_SUCCESS,
    MARK_CALL_RECEIVED_FAILURE,
  } from "../types/callActionTypes"
  
  const initialState = {
    loading: false,
    error: null,
    success: false,
  };
  
  const callReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_CALL_STATUS_START:
        return {
          ...state,
          loading: true,
          error: null,
          success: false,
        };
  
      case UPDATE_CALL_STATUS_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
        };
  
      case UPDATE_CALL_STATUS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: false,
        };
        case MARK_CALL_RECEIVED_START:
            return {
              ...state,
              loading: true,
              error: null,
              success: false,
            };
      
          case MARK_CALL_RECEIVED_SUCCESS:
            return {
              ...state,
              loading: false,
              success: true,
            };
      
          case MARK_CALL_RECEIVED_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.payload,
              success: false,
            };
      
      default:
        return state;
    }
  };
  
  export default callReducer;
  